module.exports = __webpack_public_path__ + "img/core-enroll-logo.24bd55e2.png";